import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { Fancybox } from "@fancyapps/ui";
import initMobileNav from "./components/mobileNav";
import initOpenClose from "./components/openClose";
import ready, { HTML } from "./utils";
import chooseVariation from "./components/chooseVariation";
import initCatalogue from "./components/catalogue";

ready(() => {
  window.Alpine = Alpine;
  Alpine.plugin(focus);
  Alpine.start();

  HTML.classList.add("is-loaded");
  initMobileNav();
  initOpenClose();
  chooseVariation();
  initCatalogue();

  Fancybox.bind("[data-fancybox]", {});
});
